<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card style="border-radius:1.5em;">
        <div slot="header">
          <h3 class="card-title mb-0">Datos básicos</h3>
        </div>
        <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <CompanySelector v-model="companyId"/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Fecha inicial *</label>
            <vs-input type="date" v-model="initialDate" class="w-100 "/>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Fecha final *</label>
            <vs-input type="date" v-model="finalDate" class="w-100 "/>
          </vs-col>
        </vs-row>
        <br/>
        <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Tipo de vehículo *</label>
            <b-select placeholder="Seleccione tipo de vehículo" expanded v-model="initials" name="vehicleType">
              <option v-for="option in initialsList" :value="option.code" :key="option.code" :id="option.code">
                {{ option.description }}
              </option>
            </b-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Tipo de movimiento *</label>
            <b-select placeholder="Seleccione tipo de movimiento" expanded v-model="typeMovement" name="typeMovement">
              <option v-for="option in typeMovementList" :value="option.code" :key="option.code" :id="option.code">
                {{ option.description }}
              </option>
            </b-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
            <label>Consecutivo</label>
            <vs-input type="text" v-model="consecutive" class="w-100"/>
          </vs-col>
        </vs-row>
        <hr class="custom-hr"/>
        <div class="d-inline-block d-md-flex align-items-center">
          <div class="btn-alignment">
            <vs-button
                @click="search()">Buscar
            </vs-button>
            <vs-button color="gray"
                       @click="clearForm()">Limpiar
            </vs-button>
          </div>
          <div class="ml-auto mt-3 mt-md-0">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                <vs-button
                    :disabled="!isActivatePurge"
                    @click="save()">Purgar
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
      <div style="max-height: 25em; overflow-y: auto;">
        <vs-card style="border-radius: 1.5em;">
          <vs-table
              multiple
              max-items="50"
              pagination
              v-model="selected"
              :data="movementList">
            <template slot="header">
              <h3>
                Movimientos
              </h3>
            </template>
            <template slot="thead">
              <vs-th sort-key="id">Consecutivo</vs-th>
              <vs-th sort-key="checkIn">Fecha de entrada</vs-th>
              <vs-th sort-key="cheviceEntry">Sitio entrada</vs-th>
              <vs-th v-show="showPlate" sort-key="plate">Placa</vs-th>
              <vs-th v-show="showMovil" sort-key="movil">Teléfono</vs-th>
              <vs-th v-show="showIdentification" sort-key="identification">Cédula</vs-th>
              <vs-th v-show="showSlot" sort-key="title">Lote</vs-th>
              <vs-th v-show="showLocation" sort-key="location">Cupo asignado</vs-th>
              <vs-th v-show="showPrefix" sort-key="prefix">Prefijo</vs-th>
              <vs-th v-show="showBillNumber" sort-key="billNumber">Numero factura</vs-th>
              <vs-th v-show="showTotal" sort-key="total">Total</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].movement.consecutive">
                  {{ data[indextr].movement ? (data[indextr].movement.consecutive || 'N/A') : 'N/A' }}
                </vs-td>
                <vs-td :data="data[indextr].movement.checkIn">
                  {{ data[indextr].movement ? (data[indextr].movement.checkIn || 'N/A') : 'N/A' }}
                </vs-td>
                <vs-td>
                  {{
                    data[indextr].movement ? (data[indextr].movement.deviceEntry ?
                        data[indextr].movement.deviceEntry.title || 'N/A' : 'N/A') : 'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showPlate">
                  {{
                    data[indextr].movement ? (data[indextr].movement.vehicle
                        ? data[indextr].movement.vehicle.identification || 'N/A' : 'N/A') : 'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showMovil">
                  {{
                    data[indextr].movement ? (data[indextr].movement.info
                        ? (data[indextr].movement.info.dataUser ? data[indextr].movement.info.dataUser.movil || 'N/A' : 'N/A') : 'N/A') : 'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showIdentification">
                  {{
                    data[indextr].movement ? (data[indextr].movement.info
                        ? (data[indextr].movement.info.dataUser ? data[indextr].movement.info.dataUser.identification || 'N/A' : 'N/A') : 'N/A') : 'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showSlot">
                  {{
                    data[indextr].movement ? (data[indextr].movement.slot ? data[indextr].movement.slot.title || 'N/A' : 'N/A') :
                        'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showLocation">
                  {{
                    data[indextr].movement ? (data[indextr].movement.info
                        ? (data[indextr].movement.info.dataUser ? data[indextr].movement.info.dataUser.location || 'N/A' : 'N/A') : 'N/A') : 'N/A'
                  }}
                </vs-td>
                <vs-td v-show="showPrefix">
                  {{ data[indextr].prefix || 'N/A' }}
                </vs-td>
                <vs-td v-show="showBillNumber">
                  {{ data[indextr].billNumber || 'N/A' }}
                </vs-td>

                <vs-td v-show="showTotal">
                  {{ data[indextr].total || 'N/A' }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>

import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import MovementEndpoint from "@/endpoints/income/MovementEndpoint";
import toast from "@/global/ToastConfig";
import movementEndpoint from "@/endpoints/income/MovementEndpoint";
import DateUtils from "@/global/DateUtils";
import {VEHICLE_TYPE} from "@/global/constants";
import {TYPE_MOVMENTS} from "@/global/constants";
import LangSelector from '@/components/Shared/LangSelector.vue';


export default {

  name: "purgeMovement",
  components: {
    CompanySelector,
    LangSelector
  },
  data() {
    return {
      initialDate: null,
      finalDate: null,
      selected: [],
      initialsList: [],
      typeMovementList: [],
      typeMovement: null,
      initials: null,
      showLocation: true,
      showMovil: true,
      showIdentification: true,
      showSlot: true,
      showPrefix: false,
      showBillNumber: false,
      showTotal: false,
      showPlate: false,
      isLoading: false,
      companyId: null,
      selectAll: false,
      selectedItems: [],
      forceRender: 0,
      descriptionItems: [10, 50, 100],
      movementList: [],
      isActivatePurge: false,
      rangeMax:31,
    }
  },
  mounted() {
    this.initialsList = this.getItemType();
    this.typeMovementList = this.getTypeMovement();
  },
  watch: {
    companyId() {

    },
    selected(newSelected) {
      this.movementSelected = newSelected;
      this.isActivatePurge = this.selected.length > 0;
    },
    initials(){
      this.movementList = [];
      this.selected=[];
    },
    typeMovement(){
      this.movementList = [];
      this.selected=[];
    }

  },
  methods: {
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.movementList = [];
      this.initials = null;
      this.typeMovement = null;
      this.selected=[];
    },
    search() {
      this.movementList = [];
      this.selected=[];
      this.processFindMovment();
    },
    processFindMovment() {
      try {
        this.validateForm();
        this.showColumn();
        this.findMovementByCompany();
      } catch (ex) {
        toast.error(ex.message);
      }

    },
    showColumn() {
      let isBike = 'BI' === this.initials;
      this.showLocation = isBike;
      this.showIdentification = isBike;
      this.showMovil = isBike;
      this.showSlot = isBike;
      this.showPrefix = !isBike;
      this.showBillNumber = !isBike;
      this.showTotal = !isBike;
      this.showPlate = !isBike;
    },
    getItemType() {
      const list = [];
      for (const key in VEHICLE_TYPE) {
        if (Object.hasOwnProperty.call(VEHICLE_TYPE, key)) {
          const itemStatus = VEHICLE_TYPE[key];
          list.push(itemStatus);
        }
      }
      return list;
    },
    getTypeMovement() {
      const list = [];
      for (const key in TYPE_MOVMENTS) {
        if (Object.hasOwnProperty.call(TYPE_MOVMENTS, key)) {
          const itemStatus = TYPE_MOVMENTS[key];
          list.push(itemStatus);
        }
      }
      return list;
    },
    findMovementByCompany() {
      let startDate = DateUtils.startDate({date: this.initialDate,});
      let endDate = DateUtils.endDate({date: this.finalDate});
      let isIncome = 'ROTA' !== this.typeMovement;
      this.isLoading = true;
      MovementEndpoint.findMovementByCompany(startDate.format('YYYY-MM-DD HH:mm:ss'), endDate.format('YYYY-MM-DD HH:mm:ss'),
          this.initials, isIncome, this.consecutive)
          .then(data => {
            this.isLoading = false;
            this.movementList = data;
          });
    },
    save() {
      try {
        this.validateSave();
        this.isLoading = true;
        movementEndpoint.save(this.selected)
            .then(result => {
              if (result > 0) {
                toast.ok("Se purgó y liberó correctamente");
                this.movementList = [];
                this.selected = [];
              }
              this.isLoading = false;
            });
      } catch (ex) {
        toast.error(ex.message);
      }
    },
    validateSave() {
      if (!this.selected || this.selected.length <= 0) {
        throw new Error("Por favor seleccionar movimientos");
      }
    },
    validateForm() {
      if (!this.initialDate || !this.finalDate) {
        throw new Error("Debe seleccionar fecha desde y/o fecha hasta");
      }
      if (!this.initials) {
        throw new Error("Debe selecciona un tipo de vehiculo");
      }
      if (!this.typeMovement) {
        throw new Error("Debe seleccionar un tipo de movimiento");
      }
      const isBefore = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (isBefore) {
        throw new Error(" La fecha final no puede ser inferior a la fecha inicial");
      }
      const range = DateUtils.differenceInDays(this.initialDate,this.finalDate);
      if (range > this.rangeMax ) {
        throw new Error("El rango máximo permitido es de "+this.rangeMax+" días");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if(this.consecutive && this.consecutive.length > 20) {
        throw new Error(this.$t('purgeMovement.errors.consecutiveTooLong'));
      }
    }
  }
}
</script>